import { R400 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

export const transparentLozengeStyle = {
	backgroundColor: 'transparent',
	color: token('color.text.subtlest', '#626F86'),
};

export const deletedEntityIndicatorStyle = {
	display: 'flex',
	alignItems: 'center',
	color: token('color.icon.danger', R400),
	gap: token('space.050', '4px'),
};
